"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseText = parseText;
exports.getClassNames = getClassNames;
exports.pick = pick;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parseText(child, variables) {
  return Object.keys(variables || {}).reduce(function (finalString, vName) {
    return finalString.replace("#".concat(vName, "#"), variables[vName]);
  }, child);
}

function getClassNames(DOM) {
  var classNames = [];

  if ((DOM.props.className || '').trim().length > 0) {
    classNames = (DOM.props.className || '').split(/\s*\s\s*/);
  }

  return classNames;
}

function pick(object, attributes) {
  return attributes.reduce(function (finalObject, attribute) {
    return _objectSpread(_objectSpread({}, finalObject), {}, _defineProperty({}, attribute, object[attribute]));
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux-pdfs/dist/DOMComponents/Utilities.js
// module id = 3
// module chunks = 0